import { useContext, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

import { AuthContext } from 'contexts/AuthContext';

import { Input } from 'sections/Form';
import { useNavigate } from 'react-router-dom';
import { routes } from 'data/routes';

const useForgotPassword = () => {
  const { handleSubmit, register } = useForm();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [stepTwo, stepTwoSet] = useState(false);
  const [email, emailSet] = useState('');
  const [error, errorSet] = useState('');

  const getCode = async (data: FieldValues) => {
    try {
      emailSet(data.email);
      await authContext.forgotPassword(data.email, () => stepTwoSet(true));
    } catch (err) {
      if (err instanceof Error) {
        errorSet(err?.message);
      } else {
        errorSet('Unexpected error');
      }
    }
  };

  const changePassword = async (data: FieldValues) => {
    if (data.password !== data.passwordConfirm) {
      errorSet('Passwords are not equal');

      return;
    }

    try {
      await authContext.confirmPassword(email, data.code, data.password).then(() => {
        authContext.isNewPasswordSet(true);
        navigate(routes.login);
      });
    } catch (err) {
      if (err instanceof Error) {
        errorSet(err?.message);
      } else {
        errorSet('Unexpected error');
      }
    }
  };

  const inputs: Input[] = [
    {
      name: 'email',
      label: 'email:',
    },
  ];

  const secondaryInputs: Input[] = [
    {
      name: 'code',
      label: 'verification code:',
    },
    {
      name: 'password',
      label: 'new password:',
      type: 'password',
      autocomplete: false,
    },
    {
      name: 'passwordConfirm',
      label: 'confirm password:',
      type: 'password',
      autocomplete: false,
    },
  ];

  return {
    handleSubmit,
    register,
    getCode,
    changePassword,
    inputs,
    stepTwo,
    secondaryInputs,
    error,
  };
};

export { useForgotPassword };
